import { render, staticRenderFns } from "./MyBalanceDepositTable.vue?vue&type=template&id=2b129b6f&"
import script from "./MyBalanceDepositTable.vue?vue&type=script&lang=js&"
export * from "./MyBalanceDepositTable.vue?vue&type=script&lang=js&"
import style0 from "./MyBalanceDepositTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports